import "./Searchbar.css";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSidebarOpen,
  toggleSidebar,
} from "../../features/Dashboard/Slices/dashboardSlice";
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import SlButton from "@shoelace-style/shoelace/dist/react/button";
import { selectUser } from "../../features/Dashboard/Slices/userSlice";
import useAuth from "../../hooks/useAuth";

function Searchbar() {
  const dispatch = useDispatch();
  const sidebarOpen = useSelector(selectSidebarOpen);
  const { logout } = useAuth();
  const { email, rol } = useSelector(selectUser);

  const toggleLeftBar = async () => {
    await dispatch(toggleSidebar());
  };

  return (
    <div className={`searchBar ${!sidebarOpen ? "searchbar-full-width" : ""}`}>
      <button onClick={toggleLeftBar}>
        <SlIcon
          name={`${sidebarOpen ? "text-indent-right" : "text-indent-left"}`}
          className="text-primary toggleIcon"
        />
      </button>
      <div className="header-user-info">
        {email && rol && (
          <p>
            <span>{rol}</span>
            {email}
          </p>
        )}
        <SlButton
          size="small"
          type="button"
          variant="danger"
          outline
          onClick={logout}
          title="Cerrar sesión"
        >
          <SlIcon slot="suffix" name="door-closed"></SlIcon>
        </SlButton>
      </div>
    </div>
  );
}

export default Searchbar;
